var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireFlameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0_15374_63692)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_15374_63692",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_15374_63692",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_15374_63692",
    width: 24,
    height: 24,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAdxJREFUSInNlT9IlVEYxp+jBiokBBkqgUGgNDjU4m1xkFCbwpbAiuagpa22aGlqTGxoqEUc1KGmlIjApakaJFqKKMW6FTcyKm/+GnxuHr33++OfoGd5v/Oe9/09597zfvdK/5OAPcBZYAJYAJ7sJrwAvKRae3cDPgR8N/AVcAl453X3TuFtQNGwUaDJ+SnnLuzU4LpB94EQ5S86Pxfnt2Pw3KC+TflmYMl7l7cCHAAGo3Up6TKBU8AqUAZG8sDbgZ/AcpQr26A+oeeq91eA4SyDK9H41W0yaEzpq9zTt8SpAoJHsKJGoM5fwe+KYYrJXfc9SCroYaN6gW4/v0396Gv9+4BlH6azko9PVXBcdRyVdNvPs1kGIYQvkh6a+XfiGqKaVsc7kk5KOub1R0nXsgys144dtQy+Ov6QdFTSGUllSdMhhA85DVYcqWWw5HgohFCUdCsnNNZ+x2LVDnDQF/oJaKgqyCHghRnHswrObQPe45EuJR4QOG+D90DbFuD1wIx7b2YVPnLhPHAkB7wFGHfPInAgq6EVeOaGX8A94DTQCTT5DW8HTgA3WP9FLQGFVHhk0gyM2SCPHgOHa7FS/yj8yo9I6pfUpbUxDJI+S3ojaU7SZAjhaa6T/wv9Ac4LWQhHihISAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireFlameIcon);
export default __webpack_public_path__ + "static/media/fire-flame-icon.2170bb2b31c4a6bda0df78059b0e3c88.svg";
export { ForwardRef as ReactComponent };